"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryParseEnvValue = void 0;
/**
 * Method to parse JSON-formatted environment variables
 * @param {string} envValue - can be undefined when providing values via process.env
 * @param {T} defaultValue - default value
 * @returns {T | string} parsed value
 */
const tryParseEnvValue = (envValue, defaultValue) => {
    if (!envValue) {
        return defaultValue;
    }
    if (envValue.startsWith('{') && envValue.endsWith('}')) {
        try {
            return JSON.parse(envValue);
        }
        catch (error) {
            console.warn('Parsing of env variable failed');
            console.warn(`Attempted to parse ${envValue}`);
            return defaultValue;
        }
    }
    return defaultValue;
};
exports.tryParseEnvValue = tryParseEnvValue;
